import { render, staticRenderFns } from "./CompEventsGridCard.vue?vue&type=template&id=6baf00fa&scoped=true"
import script from "./CompEventsGridCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompEventsGridCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf00fa",
  null
  
)

export default component.exports